/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Title_LeadInputs */

const en_start_page_title_lead = /** @type {(inputs: Start_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first booking,`)
};

const pl_start_page_title_lead = /** @type {(inputs: Start_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwsza rezerwacja`)
};

/**
* | output |
* | --- |
* | "Your first booking," |
*
* @param {Start_Page_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_title_lead = /** @type {((inputs?: Start_Page_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_title_lead(inputs)
	return en_start_page_title_lead(inputs)
});